import { SITE_CONTACT } from '../config/site'
import {
  PRIVACY_POLICY_INTRO,
  PRIVACY_POLICY_SECTIONS,
  PRIVACY_POLICY_UPDATED_AT,
} from '../data/privacyPolicy'

export default function PoliticaPrivacidadePage() {
  return (
    <main>
      <section className="relative overflow-hidden px-[5%] pt-36 pb-18 md:pt-44 md:pb-24">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        <div className="max-w-[1180px] mx-auto grid gap-12 lg:grid-cols-[1.15fr_0.85fr] lg:items-end">
          <div>
            <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--green)] mb-6">
              <span className="h-2 w-2 rounded-full bg-[var(--green)]" />
              Privacidade
            </span>
            <h1 className="font-heading text-[clamp(2.2rem,7vw,4.8rem)] font-semibold leading-[1.02] tracking-[-0.04em] max-w-[10ch]">
              Política de Privacidade
            </h1>
          </div>

          <div className="space-y-6 text-text-muted text-[1rem] md:text-[1.08rem] leading-[1.8] max-w-[560px]">
            {PRIVACY_POLICY_INTRO.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <p className="text-text-main">Última atualização: {PRIVACY_POLICY_UPDATED_AT}.</p>
          </div>
        </div>
      </section>

      <section id="politica-de-privacidade" className="px-[5%] py-18 md:py-24">
        <div className="max-w-[1180px] mx-auto">
          <div className="mb-12 md:mb-16 grid md:grid-cols-[180px_1fr] md:gap-12 items-end">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--green)] mb-4 md:mb-0 md:pb-[0.3em]">
              Transparência
            </p>
            <h2 className="font-heading text-[clamp(1.9rem,4.5vw,3.4rem)] font-semibold tracking-[-0.03em] leading-[1.08]">
              Como tratamos os seus dados.
            </h2>
          </div>

          <div className="grid gap-6 md:gap-8">
            {PRIVACY_POLICY_SECTIONS.map((section) => (
              <article
                key={section.title}
                className="group grid gap-5 rounded-[24px] border border-white/[0.07] bg-white/[0.02] p-6 md:p-8 lg:grid-cols-[120px_1fr] lg:gap-8 transition-colors duration-300 hover:border-[var(--green)]/30"
              >
                <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--green)]">
                  {section.index}
                </div>
                <div>
                  <h3 className="font-heading text-[1.45rem] md:text-[1.8rem] font-semibold tracking-[-0.02em] leading-[1.15] mb-4 text-text-main">
                    {section.title}
                  </h3>
                  <div className="space-y-4 text-text-muted text-[0.98rem] md:text-[1.05rem] leading-[1.8]">
                    {section.paragraphs.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                    {section.items && (
                      <ul className="flex flex-col gap-3 list-none m-0 p-0">
                        {section.items.map((item) => (
                          <li key={item.text} className="flex gap-3">
                            <span
                              aria-hidden="true"
                              className="mt-[0.7em] h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--green)]"
                            />
                            <span>
                              {item.label && <span className="text-text-main">{item.label}: </span>}
                              {item.text}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}
                    {section.showContactEmail && (
                      <p>
                        <a
                          href={`mailto:${SITE_CONTACT.email}`}
                          className="font-mono text-[13px] text-[var(--green)] hover:text-text-main transition-colors duration-200"
                        >
                          {SITE_CONTACT.email}
                        </a>
                      </p>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  )
}
